import logger from './utils/logger.js';
import { formatProductName } from './utils/product.js';

// Function: Pushes add_to_wishlist event to dataLayer
// Specs:
// - This function should be called whenenever a user selects a payment method, on the checkout page
const dataLayerWishlist = (items, locale, siteFilters) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'add_to_wishlist',
        ecommerce: {
            currency: items[0].product.price_range.maximum_price.regular_price.currency,
            value: items[0].product.price_range.maximum_price.regular_price.value,
            items: items.map(item => {
                var _a;
                return ({
                    item_name: formatProductName({
                        name: item.product.name,
                        lang: locale,
                        siteFilters: siteFilters || null,
                    }),
                    // TODO: GA4 - For Kit and Configurable products, we need to add the parent product SKU to the item_id field
                    item_id: item.product.sku,
                    discount: ((_a = item.product.price_gap) === null || _a === void 0 ? void 0 : _a.value) || 0,
                    price: item.product.price_range.maximum_price.final_price.value,
                    quantity: 1,
                });
            }),
        },
    });
    logger('add_to_wishlist event sent', { category: 'analytics' });
};

export { dataLayerWishlist as d };
//# sourceMappingURL=wishlist-foOHzuD7.js.map
